import NextHead from "next/head"

import { HeadTitle } from "layouts/components/Head/head.types"

export function RundooHead({ headTitle }: { headTitle: HeadTitle }) {
  return (
    <NextHead>
      <title>{headTitle}</title>
      <link rel="icon" href="/favicon.ico" />
    </NextHead>
  )
}
